import React from 'react';
import CustomLocalizationProvider from 'common/CustomLocalizationProvider/CustomLocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { CustomTimePickerProps } from './interfaces';

export default function CustomTimePicker({
  label,
  views,
  minutesStep,
  sx,
  value,
  minTime,
  slotProps = {},
  onChange,
  onClose,
  viewRenderers,
  timeSteps,
}: CustomTimePickerProps) {
  return (
    <CustomLocalizationProvider>
      <TimePicker
        label={label}
        views={views}
        minutesStep={minutesStep}
        timeSteps={timeSteps}
        ampm={false}
        sx={sx}
        minTime={minTime}
        value={value}
        onChange={onChange}
        onClose={onClose}
        viewRenderers={viewRenderers}
        slotProps={{
          popper: {
            sx: {
              '& .MuiMultiSectionDigitalClockSection-root': {
                width: '8rem',
                overflowY: 'scroll',
              },
            },
          },
          ...slotProps,
        }}
      />
    </CustomLocalizationProvider>
  );
}
